import { identityKey } from '../../../helpers/gtin'

/** Busca por nome no catálogo ou colagem/CSV de EANs. */
export type PickerMode = 'search' | 'batch'

export type ProductCandidate = {
  /** EAN, ou `publisher:sku` no item por SKU. */
  key: string
  identifierType: AdvertiserBrandIdentifierType
  gtin: string | null
  sku: string | null
  /** Só no item por SKU: o publisher onde o código vale. */
  publisher: AdvertiserBrandPublisher | null
  name: string
  imageUrl: string | null
  /** Marca que já vem com a linha, da lista de sugestões. */
  suggestedBrand: string | null
  /** Marca da mesma linha do arquivo ou da colagem, na aba de lista. */
  fileBrand: string | null
  /** Aba que produziu a linha: a de lista nunca traz marca. */
  origin: PickerMode
}

export type ProductSelection = Record<string, ProductCandidate>

/** O que o picker lê de um item do catálogo ou de uma sugestão. */
export type CatalogHit = {
  identifier_type: AdvertiserBrandIdentifierType
  gtin: string | null
  product_sku: string | null
  publisher: AdvertiserBrandPublisher | null
  name: string
  image_url: string | null
}

export const toCandidate = (
  hit: CatalogHit,
  origin: PickerMode,
  suggestedBrand: string | null = null,
  fileBrand: string | null = null
): ProductCandidate => {
  const isSku = hit.identifier_type === 'sku'
  const gtin = isSku ? null : hit.gtin
  const sku = isSku ? hit.product_sku : null
  const publisher = isSku ? hit.publisher : null

  return {
    key: identityKey({ gtin, sku, publisherId: publisher?.id ?? null }),
    identifierType: hit.identifier_type,
    gtin,
    sku,
    publisher,
    name: hit.name,
    imageUrl: hit.image_url,
    suggestedBrand,
    fileBrand,
    origin
  }
}

/** Produto a cadastrar na forma do candidato. */
export const toProductInput = (
  row: ProductCandidate,
  source: AdvertiserBrandSource
): AdvertiserBrandProductInput => {
  const identity =
    row.identifierType === 'sku'
      ? { sku: row.sku, publisher_id: row.publisher?.id }
      : { gtin: row.gtin }

  return { ...identity, product_name: row.name, source }
}
